// extracted by mini-css-extract-plugin
var _1 = "kaOgSBAIRT9HBS1SeoLw";
var _2 = "osQdACCagbglX7VPhEVQ";
var _3 = "RjF2DEcbVAPBAIfD5WAY";
var _4 = "T5z1xw7ixPJCUkMKzOAQ";
var _5 = "cxmkYS1NYboSBubosxic";
export { _1 as "description", _2 as "duplicateGroup", _3 as "invalidTable", _4 as "section", _5 as "title" }
